import React from 'react'

const Widget = ({ children, style, ...props }) => (
  <div
    style={{
      border: '1px solid #285978',
      padding: 6,
      ...style,
    }}
    {...props}
  >
    {children}
  </div>
)

export default Widget



// WEBPACK FOOTER //
// ./src/cms/Widget.js